// REACT & Libraries
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

// Table
import BarangayTable from "../../DataTables/MasterData/Barangay/BarangayTable";

// Modals
import CreateBarangayModal from "../../UiKits/Modal/MasterData/Barangay/CreateBarangay";

const BarangayContainer = () => {
  return (
    <>
      <Breadcrumbs
        mainTitle="Barangay"
        parent="Master Data / Address & Location"
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <H5 className="mb-0">Barangay Master Data</H5>
                <P className="mb-3 f-light f-w-200 f-12">
                  Manage barangay options used throughout the HRIS for employee
                  and applicant personal information.
                </P>
                <CreateBarangayModal />
                <BarangayTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default BarangayContainer;
